import {createAction, props} from '@ngrx/store';

export enum AppActionsTypes {
  SetMenuOpened = '[App] setMenuOpened',
  SetPalette = '[App] setPalette',
  SetLogo = '[App] setLogo',
  Clear = '[App] clear'
}

export const setMenuOpened = createAction(AppActionsTypes.SetMenuOpened, props<{ menuOpened: boolean }>());
export const setPalette = createAction(AppActionsTypes.SetPalette, props<{ palette: string }>());
export const setLogo = createAction(AppActionsTypes.SetLogo, props<{ logo: string }>());
export const appClear = createAction(AppActionsTypes.Clear);

